import { type CurrentAsset, type StepTwoFormValues } from '../types';

/**
 * Assets carried forward from Review into the Add Unit # and registration
 * steps: everything that can be added or edited — new assets, those re-homed
 * from another fleet or depot, and those already in the target depot (shown
 * here so their unit numbers can be edited). Invalid VINs are skipped.
 */
export const collectAssetsToAdd = (
  stepTwo: StepTwoFormValues,
): CurrentAsset[] => [
  ...(stepTwo.validVins ?? []),
  ...(stepTwo.usedByOther ?? []),
  ...(stepTwo.usedByOtherDepot ?? []),
  ...(stepTwo.ownedByCurrent ?? []),
];
